<template>
    <div class="work-explore">
        <router-link class="work-explore__close-btn-link" to="/work">
            <img class="work-explore__close-btn" src="/assets/imgs/close.png" alt="Close">
        </router-link>

        <div class="work-explore-filters">
            <div class="work-explore-filters__show-hide" v-on:click="toggleFilterShowHide">FILTER BY Expertise <span><img src="/assets/imgs/filter-triangle.png" class="work-explore-filters__show-hide-filter-arrow" style="padding-bottom:2px;" alt=""></span></div>

            <div class="work-explore-filters__container" :class="{ active: isFilterOpen }">
                <ul class="work-explore-filters__list">
                    <li class="work-explore-filters__list-item">
                        <button class="work-explore-filters__filter-btn" v-on:click="resetFilters()" :class="{active : (filtersSelectedArray.length <= 0)}">SHOW ALL</button>
                    </li>

                    <li class="work-explore-filters__list-item" v-for="(filtersData, index) in filtersDataArray" :key="index">
                        <button class="work-explore-filters__filter-btn" v-on:click="toggleFilter(filtersData.Id)" :class="{active : filtersSelectedArray.includes(filtersData.Id), disabled : ((filtersSelectedArray.length >= 3) && !filtersSelectedArray.includes(filtersData.Id))}">{{filtersData.Label}}</button>
                    </li>
                </ul>
            </div>
        </div>

        <ul class="work-explore__list">
            <li v-for="(galleryItem, index) in galleryItems" :key="index" class="work-explore__item" :class="{wide: (galleryItem.size === 'wide'), tallLeft: (galleryItem.size === 'tall-left'), tallRight: (galleryItem.size === 'tall-right')}" @mouseenter="onMouseEnterHandler(`gallery-item-${index}`)" @mouseleave="onMouseLeaveHandler">
                <router-link :to="galleryItem.url" class="work-explore__link">
                    <div class="work-explore__content">
                        <h2 class="work-explore__heading" v-html="galleryItem.title"></h2>
                        <h3 class="work-explore__sub-heading" v-html="galleryItem.subTitle"></h3>
                    </div>

                    <auto-player
                        :playerId="`gallery-item-${index}`"
                        :vimeoVideoUrl="galleryItem.videoUrl"
                        :selectedTileId="selectedTileId"
                        @on:selectidchange="selectedTileId = $event"
                    >
                        <picture>
                        <source
                            media="(max-width: 640px)"
                            :srcset="galleryItem.thumbnailMobile"
                        />
                        <source
                            media="(min-width: 641px)"
                            :srcset="galleryItem.thumbnail"
                        />
                        <img
                            class="work-explore__image"
                            :src="galleryItem.thumbnail"
                            :alt="galleryItem.imageAltText"
                        />
                        </picture>
                    </auto-player>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<style scoped lang="less">
    @import "../less/app.less";
    @import "../less/breakpoints.less";
    
    .work-explore {
        background-color: #ffffff;
        margin: 0 auto;
        padding: 100px 20px;
        position: relative;

        @media @breakpoint__tablet--medium {
            padding: 80px 20px;
        }
    }

    .work-explore__close-btn-link {
        display: block;
        left: 25px;
        position: absolute;
        top: 20px;
        z-index: 100;

        @media @breakpoint__mobile--large {
            left: 15px;
        }
    }

    .work-explore__close-btn {
        cursor: pointer;
        display: block;
        //transform: scale(0);
        width: 49px;
        z-index: 70;

        @media @breakpoint__mobile--large {
            width: 36px;
        }
    }

    .work-explore-filters {
        margin-bottom: 50px;
        opacity: 0;
        transform: translateY(20px);

        @media @breakpoint__tablet--small {
            margin-bottom: 40px;
        }
    }

    .work-explore-filters__show-hide {
        color: #003a4a;
        cursor: pointer;
        display: table;
        font-size: 20px;
        letter-spacing: 1.3px;
        margin: 0 auto;
        max-width: 700px;
        padding: 20px;
        text-transform: uppercase;

        .work-explore-filters__show-hide-filter-arrow {
            transition: 0.3s transform;
        }

        &.active {
            .work-explore-filters__show-hide-filter-arrow {
                padding-top: 2px;
                transform: rotate(180deg);
            }
        }
    }

    .work-explore-filters__list {
        list-style-type: none;
        padding: 0;
        margin: 0 auto;
        padding: 20px;
        max-width: 700px;
        text-align: center;
    }

    .work-explore-filters__list-item {
        display: inline-block;
    }

    .work-explore-filters__filter-btn {
        border: 1px solid #e40046;
        border-radius: 5px;
        background: #fff;
        color: #003a4a;
        cursor: pointer;
        font-family: Flama, Arial, Helvetica, sans-serif;
        font-size: 18px;
        letter-spacing: 0.2px;
        line-height: 1;
        margin: 10px 5px;
        padding: 3px 5px 3px;
        text-transform: uppercase;
        transition: 0.3s all;

        &:focus {
            outline: none;
        }

        &:hover {
            background: #e40046;
            color: #ffffff;
        }

        &.active {
            background: #e40046;
            color: #ffffff;

            &:hover {
                border: 1px solid #e40046;
            }
        }

        &.disabled {
            border: 1px solid #003a4a;
            cursor: default;
            opacity: 0.3;
            
            &:hover {
                background: #ffffff;
                color: #003a4a;
            }
        }
    }

    .work-explore-filters__container {
        height: 0;
        overflow: hidden;
    }

    .work-explore__list {
        .clearfix();
        max-width: 1300px;
        margin: 0 auto;
        padding: 0;
    }

    .work-explore__item {
        box-sizing: border-box;
        float: left;
        list-style-type: none;
        padding: 0 1.2% 2.4%;
        width: calc(~"100% / 2");
        visibility: hidden;

        @media @breakpoint__tablet--small {
            width: calc(~"100% / 2");
        }

        @media @breakpoint__mobile--large {
            padding: 0 0 6%;
            width: 100%;
        }

        &.wide {
            width: 100%;

            @media @breakpoint__tablet--small {
                width: calc(~"100% / 2");
            }

            @media @breakpoint__mobile--large {
                width: 100%;
            }
        }

        &.tallRight {
            float: right;
        }

        .work-explore__image {
            display: block;
            width: 100%;
        }
    }

    .work-explore__link {
        -webkit-mask-image: -webkit-radial-gradient(white, black);
        border-radius: 55px;
        display: block;
        overflow: hidden;
        position: relative;

        @media @breakpoint__tablet--medium{
            border-radius: 40px;
        }

        @media @breakpoint__tablet--small {
            border-radius: 25px;
        }

        &:before {
            content: "";
            background-color: #003A4A;
            height: 100%;
            left: 0;
            opacity: 0;
            position: absolute;
            transition: 0.3s opacity;
            top: 0;
            width: 100%;
            z-index: 10;
        }     

        &:hover {
            &:before {
                opacity: 0.78;
            }

            .work-explore__heading {
                opacity: 1;
                transform: translateY(0);
                transition-delay: 0.1s;
            }

            .work-explore__sub-heading {
                opacity: 1;
                transform: translateY(0);
                transition-delay: 0.2s;
            }
        }

        @media @breakpoint__tablet--large {
            &:before {
                opacity: 0.78;
            }

            .work-explore__heading {
                opacity: 1;
                transform: translateY(0);
                transition-delay: 0.1s;
            }

            .work-explore__sub-heading {
                opacity: 1;
                transform: translateY(0);
                transition-delay: 0.2s;
            }
        }
    }

    .work-explore__content {
        left: 50%;
        position: absolute;
        text-align: center;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 80%;
        z-index: 10;
    }

    .work-explore__heading {
        color: #fff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 26px;
        letter-spacing: 1px;
        margin: 0 0 15px 0;
        text-transform: uppercase;

        @media @breakpoint__tablet--small {
            font-size: 18px;
        }

        @media @breakpoint__mobile--large {
            font-size: 24px;
        }
    }

    .work-explore__sub-heading {
        color: #e40046;
        font-size: 24px;
        font-weight: normal;
        letter-spacing: 1px;
        margin: 0;

        @media @breakpoint__tablet--small {
            font-size: 16px;
        }

        @media @breakpoint__mobile--large {
            font-size: 22px;
        }
    }

    .work-explore__heading,
    .work-explore__sub-heading {
        opacity: 0;
        transform: translateY(40px);
        transition: 0.3s opacity, 0.3s transform;
        transition-delay: 0;
    }
</style>

<script>
    import AutoPlayer from '../components/AutoPlayer.vue';

    export default {
        name: "WorkExplore",
        data() {
            return {
                jsonData : [],
                galleryItems : [],
                galleryDataArray : {},
                isFilterOpen : false,
                isFiltered : false,
                filtersDataArray : [],
                filtersSelectedArray : [],
                selectedTileId: '',
                timeoutId: 0,
            }
        },
        components: {
            AutoPlayer,
        },
        computed: {
            isMobile() {
                const platform = navigator.userAgent.toLowerCase();
                return /(android|webos|iphone|ipad|ipod|blackberry|windows phone)/.test(platform);
            },
        },
        created: function()
        {
            var vm = this;
            var testIfDataLoaded = setInterval(function()
            {
                if (!vm.isObjectEmpty(vm.$parent.modelWorkGallery))
                {
                    clearInterval(testIfDataLoaded);
                    vm.galleryDataArray = vm.$parent.modelWorkGallery;
                    vm.initFilters(vm.$parent.modelWorkFilters);
                    vm.initGallery(vm.galleryDataArray);
                    vm.initSubTitle();
                }
            }, 500);
        },
        mounted: function()
        {
            TweenMax.set(".header__logo-sub-title-container", {width: 0});
        },
        methods: {
            onMouseEnterHandler : function(id)
            {
                if (!this.isMobile) {
                    window.clearTimeout(this.timeoutId);

                    this.timeoutId = setTimeout(() => {
                        this.selectedTileId = id;
                    }, 300);
                }
            },
            onMouseLeaveHandler : function()
            {
                if (!this.isMobile) {
                    this.selectedTileId = '';
                }
            },
            initFilters : function(data)
            {
                this.filtersDataArray = data;
            },
            initGallery : function(data)
            {
                var galleryData = data;
                this.galleryItems = [];
                this.galleryItems.splice(0, this.galleryItems.length);

                for(var i = 0; i < galleryData.length; i++)
                {
                    var workEntry = {};
                    workEntry.imageAltText = "";
                    workEntry.size = "";
                    workEntry.subTitle = "";
                    workEntry.size = "";
                    workEntry.thumbnail = "";
                    workEntry.thumbnailMobile = "";
                    workEntry.title = "";
                    workEntry.url = "";
                    this.galleryItems.push(workEntry);
                }

                this.galleryItems = [];

                for(var ii = 0; ii < galleryData.length; ii++)
                {
                    var workEntry = {};
                    workEntry.imageAltText = galleryData[ii].Image.AltText;
                    workEntry.size = galleryData[ii].Size;
                    workEntry.subTitle = galleryData[ii].TitleSub;

                    if (this.isFiltered)
                    {
                        workEntry.size = "regular";
                        workEntry.thumbnail = galleryData[ii].Image.GalleryThumbnail;
                    }
                    else
                    {
                        if (workEntry.size === "wide")
                        {
                            workEntry.thumbnail = galleryData[ii].Image.GalleryThumbnailWide;
                        }
                        else if ((workEntry.size === "tall-left") || workEntry.size === "tall-right")
                        {
                            workEntry.thumbnail = galleryData[ii].Image.GalleryThumbnailTall;
                        }
                        else
                        {
                            workEntry.thumbnail = galleryData[ii].Image.GalleryThumbnail;
                        }
                    }
                    
                    workEntry.thumbnailMobile = galleryData[ii].Image.Related;
                    workEntry.title = galleryData[ii].Title;
                    workEntry.videoUrl = galleryData[ii].VideoUrl;
                    workEntry.url = "/work/case-studies/" + galleryData[ii].Slug;
                    this.galleryItems.push(workEntry);
                }

                TweenMax.set(".work-explore__item", {opacity: 0, transform: "translateY(50%)"});

                setTimeout(function()
                {
                    TweenMax.to(".work-explore-filters", 0.6, {opacity: 1, transform: "translateY(0)"});
                    TweenMax.staggerFromTo(".work-explore__item", 0.6, {autoAlpha: 0, transform: "translateY(50%)"}, {autoAlpha: 1, transform: "translateY(0)", ease: Power2.easeOut}, 0.2);
                }, 500); 
            },
            initSubTitle : function() {
                document.querySelector(".header__logo-sub-title").innerHTML = "Work";
                TweenMax.set(document.querySelector(".header__logo-sub-title-container"), {width: "auto"});
                TweenMax.from(document.querySelector(".header__logo-sub-title-container"), 0.3, {width: 0, delay: 0.2});
            },
            toggleFilterShowHide : function(e)
            {
                e.currentTarget.classList.toggle("active");

                if (e.currentTarget.classList.contains("active"))
                {
                    TweenMax.set(document.querySelector(".work-explore-filters__container"), {height: "auto"});
                    TweenMax.from(document.querySelector(".work-explore-filters__container"), 0.4, {height: 0, ease: Power2.easeIn});
                }
                else
                {
                    TweenMax.to(document.querySelector(".work-explore-filters__container"), 0.4, {height: 0, ease: Power2.easeIn});
                }
            },
            toggleFilter : function(filterName)
            {
                var filterIndex = this.filtersSelectedArray.indexOf(filterName);

                if (filterIndex < 0)
                {
                    if (this.filtersSelectedArray.length < 3)
                    {
                        this.filtersSelectedArray.push(filterName);
                        this.applyFilters();
                    }
                }
                else
                {
                    this.filtersSelectedArray.splice(filterIndex, 1);
                    this.applyFilters();
                }
            },
            applyFilters : function()
            {

                this.galleryItems.splice(0, this.galleryItems.length);
                if (this.filtersSelectedArray.length > 0)
                {
                    var galleryDataArrayCopy = this.galleryDataArray.slice(0);
                    var filteredArray = [];

                    for (var i = 0; i < this.filtersSelectedArray.length; i++)
                    {
                        for (var ii = 0; ii < galleryDataArrayCopy.length; ii++)
                        {
                            if (galleryDataArrayCopy[ii].Filters.includes(this.filtersSelectedArray[i]))
                            {
                                filteredArray.unshift(galleryDataArrayCopy[ii]);
                                galleryDataArrayCopy.splice(ii, 1);
                            }
                        }
                    }

                    // Reverse the order of the filtered array
                    filteredArray.reverse();
                    
                    this.isFiltered = true;

                    var vm = this;
                    setTimeout(function()
                    {
                        vm.initGallery(filteredArray);
                    }, 200); 
                }
                else
                {
                    this.resetFilters();
                }
                
            },
            resetFilters : function()
            {
                this.isFiltered = false;
                this.filtersSelectedArray = [];
                this.galleryItems.splice(0, this.galleryItems.length);

                var vm = this;
                setTimeout(function()
                {
                    vm.initGallery(vm.galleryDataArray);
                }, 200); 
            }
        }
    };
</script>
